/**
 * Route configuration for authentication
 *
 * This file defines which routes are public (guest access allowed)
 * and which routes are protected (Okta authentication required).
 */

/**
 * List of public routes that allow guest access
 * These routes will use GuestSignInPage for authentication
 */
export const PUBLIC_ROUTES = [
  '/',
  '/redoc',
  '/v2',
  '/v2/redoc',
  '/dashboard',
  '/prism/reference-docs',
  '/prism/reference-docs/redoc',
  '/prism/reference-docs/v2',
  '/prism/reference-docs/v2/redoc',
  '/prism/how-to-docs',
  '/prism/change-logs',
  '/prism/markdown',
];

/**
 * Check if a given pathname is a public route
 * @param pathname - The pathname to check (e.g., window.location.pathname)
 * @returns true if the route is public, false if it requires Okta authentication
 */
export const isPublicRoute = (pathname: string): boolean => {
  return PUBLIC_ROUTES.some(route => {
    // Exact match
    if (pathname === route) {
      return true;
    }
    // Check if pathname starts with route (for nested routes)
    if (route.endsWith('/*') && pathname.startsWith(route.slice(0, -2))) {
      return true;
    }
    return false;
  });
};

/**
 * Check if a given pathname requires Okta authentication
 * @param pathname - The pathname to check
 * @returns true if the route requires Okta authentication
 */
export const isProtectedRoute = (pathname: string): boolean => {
  return !isPublicRoute(pathname);
};
